import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Res } from '../models';
import { ApiBasicService } from './api-basic.service';

@Injectable({
  providedIn: 'root'
})
export class ApiCertificatesService {

  constructor(
    private apiBasic: ApiBasicService
  ) { }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
   getReferences(params: any, moduleName): Observable<Res> {

    return this.apiBasic.getReferences(params, moduleName);
  }

  
  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  save(params: any): Observable<Res> {

    return this.apiBasic.create('products_certificate', params);
  }
}
